import React from 'react';

import * as ST from './styled';

export interface IPriceProps {
    price?: string,
    priceText?: string,
    isRowDirection?: boolean,
}

/**
 * Элемент стоимость и описание
 * @param isRowDirection - расположение в строку, по умолчанию в столбец
 */
export const PriceElement = ({
    price,
    priceText,
    isRowDirection,
} : IPriceProps): JSX.Element => {
    if (!price && !priceText) {
        return <></>;
    }

    return (
        <ST.PriceElement isRowDirection={isRowDirection}>
            <ST.PriceText data-test='price-text'>{priceText}</ST.PriceText>
            <ST.Price data-test='price'>{price}</ST.Price>
        </ST.PriceElement>
    );
};
